/******************************************************************************
 *                                                                            *
 *  Copyright (c) 2018, 2025 by AsterionDB Inc.                               *
 *                                                                            *
 *  All rights reserved.  No part of this work may be reproduced or otherwise *
 *  incorporated into other works without the express written consent of      *
 *  AsterionDB Inc.                                                           *
 *                                                                            *
 *****************************************************************************/

import React from 'react';
import {Progress, Row, Col} from 'reactstrap';

import Dropzone from 'react-dropzone';

import {AppContext} from '../AppContext';

const UPLOAD_QUEUED = 1;
const UPLOADING = 2;
const UPLOAD_COMPLETE = 3;

class UploadFiles extends React.Component
{
  acceptedFiles = [];
  uploadedFiles = [];

  containerStyle =
  {
    flexDirection: 'column',
    alignItems: 'center',
    padding: '20px',
    borderWidth: '2px',
    borderRadius: '2px',
    borderStyle: 'dashed',
    backgroundColor: '#fafafa',
    color: '#bdbdbd',
    outline: 'none',
    transition: 'border .24s ease-in-out'
  }

  constructor(props)
  {
    super(props);

    this.state =
    {
      progress: undefined,
      borderColor: '#eeeeee',
      uploading: 0,
      complete: 0,
      committing: null
    }

    this.dragEvent = this.dragEvent.bind(this);
    this.progressCB = this.progressCB.bind(this);
    this.uploadFiles = this.uploadFiles.bind(this);
    this.clearProgress = this.clearProgress.bind(this);
    this.onComplete = this.onComplete.bind(this);
  }

  clearProgress()
  {
    this.setState({progress: undefined, borderColor: '#eeeeee', committing: null});
  }

  progressCB(x, event)
  {
    let progressTotal = 0;
    this.acceptedFiles[x].progress = event.progress;
    for (let x = 0; x < this.acceptedFiles.length; x++) progressTotal += this.acceptedFiles[x].progress * 100;
    let  progress = Math.round(progressTotal / this.acceptedFiles.length);
    this.setState({progress: progress, committing: progress === 100 ? 'Committing...' : null});
  }

  dragEvent(event)
  {
    var color;
    switch (event.type)
    {
      case 'dragenter':
        color = '#2196f3'
        break;

      default:
        color = '#eeeeee';
        break;
    }
    this.setState({borderColor: color});
  }

  fileDialogEvent(event)
  {
    var color;
    switch (event)
    {
      case 'open':
        color = '#2196f3'
        break;

      case 'cancel':
        color = '#eeeeee';
        break;

      default:
        color = '#eeeeee';
        break;
    }
    this.setState({borderColor: color});
  }

  onComplete()
  {
    this.setState({committing: null});
    this.context.postNotification('success', 'Upload complete');
    this.props.onComplete();
  }

  render()
  {
    let multiple = (undefined === this.props.uploadNewVersion ? true : !this.props.uploadNewVersion);

    return(
      <Dropzone onDrop={this.uploadFiles} onDragEnter={this.dragEvent} onFileDialogOpen={this.fileDialogEvent.bind(this, 'open')} 
        onFileDialogCancel={this.fileDialogEvent.bind(this, 'cancel')} accept={this.props.acceptableTypes} maxSize={0x40000000}
        multiple={multiple} >
        {({getRootProps, getInputProps}) => 
        (
          <section className="container"><div {...getRootProps({className: 'dropzone'})} style={{...this.containerStyle, borderColor: this.state.borderColor}}>
            <input {...getInputProps()} />
            <p>Drag 'n' drop some files here, or click to select files</p>
          </div>
          {( undefined !== this.state.progress &&
          <div>
            <Row>
              <Col>Uploading: {this.state.uploading} Uploaded: {this.state.complete} Selected: {this.acceptedFiles.length}</Col>
            </Row>
            <Row>
              <Col>{this.state.committing}</Col>
            </Row>
            <Progress animated color='info' striped value={this.state.progress} />
          </div>
          )}
          </section>     
        )}
      </Dropzone>      
    )
  }

  async uploadFile(x)
  {
    var uploading = 0;
    var complete = 0;

    let formData = new FormData();
    formData.append("name", this.acceptedFiles[x].name);
    formData.append('lastModified', this.acceptedFiles[x].lastModified);
    if (undefined !== this.props.uploadNewVersion && this.props.uploadNewVersion)
    {
      formData.append("newVersion", "Y");
      formData.append("objectId", this.props.objectId);
    }
    else
      formData.append("newVersion", "N");

    formData.append("size", this.acceptedFiles[x].size);
    formData.append("file", this.acceptedFiles[x]);
  
    this.acceptedFiles[x].uploadStatus = UPLOADING;

    for (let x = 0; x < this.acceptedFiles.length; x++)
    {
      if (UPLOAD_COMPLETE === this.acceptedFiles[x].uploadStatus) complete++;
      if (UPLOADING === this.acceptedFiles[x].uploadStatus) uploading++;
    }
    this.setState({uploading, complete})

    let result = await this.context.dbTwig.callRestAPI('dgBunker', 'uploadFiles', formData, this.progressCB.bind(this, x));
    if ('success' !== result.status) this.context.dbTwig.apiErrorHandler(result, 'Unable to upload a file.');

    this.acceptedFiles[x].uploadStatus = UPLOAD_COMPLETE;
    this.uploadedFiles.push(this.acceptedFiles[x]);

    uploading = 0;
    complete = 0;
    
    for (let x = 0; x < this.acceptedFiles.length; x++)
    {
      if (UPLOAD_COMPLETE === this.acceptedFiles[x].uploadStatus) complete++;
      if (UPLOADING === this.acceptedFiles[x].uploadStatus) uploading++;
    }
    this.setState({uploading, complete})

    if (this.uploadedFiles.length !== this.acceptedFiles.length)
    {
      for (let y = 0; y < this.acceptedFiles.length; y++)
      {
        if (UPLOAD_QUEUED === this.acceptedFiles[y].uploadStatus)
        {
          this.uploadFile(y);
          break;
        } 
      }
    }
    else
    {
      setTimeout(this.clearProgress, 5000);
      setTimeout(this.onComplete, 2000);
    }
  }

  uploadFiles(acceptedFiles, rejectedFiles, event)
  {
    this.uploadedFiles = [];
    if (rejectedFiles.length) this.context.postNotification('warning', "Some of the dragged object types are not recognized or exceed the maximum allowed size (1GB).");
    if (undefined !== this.props.uploadNewVersion && this.props.uploadNewVersion && this.props.versionsMustHaveSameName &&
        acceptedFiles[0].name !== this.props.objectName)
    {
      this.context.postNotification('error', 'The name of the new version being uploaded must match the existing one.')
      return;
    }

    this.acceptedFiles = acceptedFiles;
    for (let x = 0; x < this.acceptedFiles.length; x++)
    {
      this.acceptedFiles[x].progress = 0;
      this.acceptedFiles[x].uploadStatus = UPLOAD_QUEUED;
    } 
    this.setState({uploading: 0, complete: 0});
    this.uploadedFiles = [];
    for (let x = 0; x < this.acceptedFiles.length && x < this.context.userUiProfile.concurrentFileUploads; x++) this.uploadFile(x);
  }
}

UploadFiles.contextType = AppContext;

export default UploadFiles